import { rowHasAnyError } from '../../utils'

const buildErrorColumnDef = (showErrors) => ({
  headerName: 'Error',
  field: 'error',
  cellRenderer: 'ErrorMenu',

  valueGetter: (params) => {
    if (!params?.data) return false
    return rowHasAnyError(params?.data)
  },

  comparator: (aValue, bValue) => {
    if (aValue === bValue) return 0
    if (aValue) return -1
    if (bValue) return 1
    return 0
  },

  hide: !showErrors,
  autoHeight: true,
  maxWidth: 70,
  minWidth: 70,
})

export { buildErrorColumnDef }
